
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LearningHubComponent } from './pages/learning-hub/learning-hub.component';
import { LearningHubDetailsComponent } from './pages/learning-hub-details/learning-hub-details.component';

const routes: Routes = [

 {
    path: 'learning-hub',
    component: LearningHubComponent
  },

  {
    path: 'learning-hub-details',
    component: LearningHubDetailsComponent
  },
  {
      path: 'learning-hub-details/:id',
      component: LearningHubDetailsComponent
  }



];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LearningHubRoutingModule { }
